import { createContext } from 'react';
import type { ReactNativeSDKClient } from '../client';

export interface HackleContext {
  hackle: ReactNativeSDKClient | undefined;
  userVersion: number;
}

export const HackleContext = createContext<HackleContext>({
  hackle: undefined,
  userVersion: 0,
});

export const HackleContextConsumer = HackleContext.Consumer;
export const HackleContextProvider = HackleContext.Provider;
